<script lang="ts">
  import { t } from 'svelte-i18n-lingui';
</script>


<div class="top-banner">
  <div class="top-banner__overlay"></div>
  <div class="top-banner__inner">
    <p>{@html $t`<span><b>¿Any doubt?</b> Contact our experts 9-19 Mon/Fr,</span> <span><b>¿Change your mind?</b> 14 days for returns. Fast & simple</span>`}</p>
  </div>
</div>


<style lang="scss">
  .top-banner {
    position: relative;
    background: #ffe5df;
    margin-left: -20px;
    margin-right: -20px;
    margin-bottom: 20px;

    @media (min-width: 769px) {
      margin-left: -35px;
      margin-right: -35px;
    }

    @media (min-width: 769px) {
      margin-left: 0;
      margin-right: -50px;
    }

    &__overlay {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      background: #ffe5df;
      z-index: -1;

      @media (min-width: 769px) {
        left: calc((100% - 100vw) / 2);
      }
    }

    &__inner {
      padding: 10px;

      @media (min-width: 481px) {
        padding: 12px 20px;
      }

      @media (min-width: 769px) {
        padding: 12px 20px 12px 0;
      }

      p {
        @media (max-width: 480px) {
          font-size: 12px;
        }

        @media (min-width: 481px) {
          span {
            &:first-child {
              margin-right: 8px;
            }
          }
        }
      }
    }
  }
</style>
